/**
 * DevExtreme (esm/__internal/scheduler/workspaces/m_timeline_work_week.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import registerComponent from "../../../core/component_registrator";
import { getWeekendsCount } from "../../scheduler/r1/utils/index";
import { VIEWS } from "../utils/options/constants_view";
import SchedulerTimelineWeek from "./m_timeline_week";
const TIMELINE_CLASS = "dx-scheduler-timeline-work-week";
const LAST_DAY_WEEK_INDEX = 5;
class SchedulerTimelineWorkWeek extends SchedulerTimelineWeek {
  get type() {
    return VIEWS.TIMELINE_WORK_WEEK;
  }
  constructor() {
    super(...arguments);
    this._getWeekendsCount = getWeekendsCount;
  }
  _getElementClass() {
    return TIMELINE_CLASS;
  }
  _incrementDate(date) {
    const day = date.getDay();
    if (5 === day) {
      date.setDate(date.getDate() + 2);
    }
    super._incrementDate(date);
  }
}
registerComponent("dxSchedulerTimelineWorkWeek", SchedulerTimelineWorkWeek);
export default SchedulerTimelineWorkWeek;